module.exports = __webpack_public_path__ + "img/easypay_banner.41cb933c.png";